export class SearchStatus {
    private stepSize: number;
    private currentStart: number;
    private lastLength: number;
    private inLoad: boolean;

    constructor(size: number) {
        this.stepSize = size;
        this.currentStart = 0;
        this.lastLength = 0;
        this.inLoad = false;
    }

    public reset(): void {
        this.currentStart = 0;
        this.lastLength = this.stepSize;
    }
    public hasMore(): boolean {
        return this.lastLength > 0;
    }
    public showLoading(): boolean {
        return this.hasMore() && (this.currentStart > 0);
    }
    public getCurrentStart(): number {
        return this.currentStart;
    }
    public getStepSize(): number {
        return this.stepSize;
    }
    public setLast(x: number): void {
        this.lastLength = x;
        this.currentStart += x;
        this.inLoad = false;
    }
    public startLoad(): void {
        this.inLoad = true;
    }
    public isInLoad(): boolean {
        return this.inLoad;
    }
    public remove(): void {
        this.currentStart--;
    }
}

export class PDxLazyLoadResults<T> {
    constructor() {
        this.totalCount = 0;
        this.results = [];
    }
    totalCount: number;
    results: T[];
}